<template>
    <div>
        <div class="header">
            <span class="fs30 medium">Успешная покупка!</span>
            <img src="/img/logo.svg" alt="" />
        </div>
        <div class="content pb30">
            <div class="white-bg-block h880 success-block">
                <img src="/img/checkbox.svg" alt="" />
                <span class="fs36 bold">Спасибо за покупку! <br />Холодильник закроется <br />автоматически</span>
                <a href="#" @click.prevent="close()" class="btn">Вернуться на главный экран</a>
                <span class="fs20">Отсканируйте QR код для получения чека</span>
                <div class="qr-code">
                    <qrcode :value="qr_code_url" :options="{ width: 110 }"></qrcode>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Success',
        data() {
            return {
                qr_code_url: 'https://api.briskly.online/terminal-api/v1/order/get-receipt/?order_key=7938ec15bd8be0ba64e85f0d3bed1508',
            };
        },
        created() {
            console.log(this.$route);
            console.log(this.$router);
        },
        mounted() {

        },
        methods: {
            close() {
                
            }
        },
    };
</script>

<style>
</style>
